import moment from 'moment'

export default {
    methods: {
        // empalme_archivos() {
        //     let getBackend = this.getData({ route: 'empalme_archivos', data: 1 })
        // },
        // empalme_archivos() {
        //     let getBackend = this.getData({ route: 'empalme', data: 1 })
        // },
        async watchAfiliado() {
            await this.resetDataForm({ state: 'servicios_nuevos' })
            await this.resetDataForm({ state: 'servicios_activos' })
            this.active = 0
            await this.updateCrud({ state: 'dataMultiple/' + this.namePath + '/multiple_servicios', data: this.predeterminados[this.namePath].multiple_servicios })
            let getBackend = await this.getData({ route: 'ficha_afiliado_get', data: this.searchSw.value })
            this.estado = getBackend.datos_afiliado.id_list_estado
            if (this.estado === 2) {
                getBackend.datos_afiliado.referido = null
            }
            getBackend.datos_afiliado.referido = JSON.parse(getBackend.datos_afiliado.referido)
            this.ultimoMes = getBackend.info_afiliacion.mes_periodo
            this.ultimoAno = getBackend.info_afiliacion.ano_periodo
            const await1 = this.updateDataForm({ state: 'datos_afiliado', data: getBackend.datos_afiliado })
            const await2 = this.updateDataForm({ state: 'servicios_activos', data: getBackend.servicios_activos })
            const await3 = this.updateDataForm({ state: 'info_afiliacion', data: getBackend.info_afiliacion })
            const await4 = this.updateDataForm({ state: 'servicios_nuevos', data: getBackend.servicios_nuevos })
            await Promise.all([await1, await2, await3, await4])

            for (let i = 0; i < getBackend.servicios_nuevos.length; i++) {
                let indexMultiple = _.findIndex(this.dataMultiple[this.namePath].multiple_servicios, ['name', getBackend.servicios_nuevos[i].name])
                this.$set(this.dataMultiple[this.namePath].multiple_servicios, indexMultiple, this.deepCopy(getBackend.servicios_nuevos[i]))
            }
            for (let i = 0; i < getBackend.servicios_activos.length; i++) {
                let indexMultiple = _.findIndex(this.dataMultiple[this.namePath].multiple_servicios, ['name', getBackend.servicios_activos[i].name])
                this.$set(this.dataMultiple[this.namePath].multiple_servicios, indexMultiple, this.deepCopy(getBackend.servicios_activos[i]))
            }
        },
        changeIngreso() {
            let dias = parseInt(moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('DD'))
            let mes = parseInt(moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('MM')) + 1
            let ano = moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('YYYY')

            if (mes === 13) {
                mes = 1
                ano = ano + 1
            }
            if (mes.toString() === this.dataForm[this.namePath].info_afiliacion.mes_periodo.toString() && ano.toString() === this.dataForm[this.namePath].info_afiliacion.ano_periodo.toString()) {
                if (dias > 30) {
                    dias = 30
                }
                dias = 31 - dias
                this.updateDataForm({ state: 'info_afiliacion/dias', data: dias })
                if (this.dataForm[this.namePath].info_afiliacion.id_list_novedad < 3) {
                    this.updateDataForm({ state: 'info_afiliacion/id_list_novedad', data: 1 })
                } else {
                    this.updateDataForm({ state: 'info_afiliacion/dias', data: 30 })
                }
            } else {
                this.updateDataForm({ state: 'info_afiliacion/dias', data: 30 })
                if (this.dataForm[this.namePath].info_afiliacion.id_list_novedad < 3) {
                    this.updateDataForm({ state: 'info_afiliacion/id_list_novedad', data: 2 })
                }
            }
        },
        changeAporte() {
            for (let i = 0; i < this.dataForm[this.namePath].servicios_nuevos.length; i++) {
                let indexMultiple = _.findIndex(this.dataMultiple[this.namePath].multiple_servicios, ['name', this.dataForm[this.namePath].servicios_nuevos[i].name])
                this.$set(this.dataMultiple[this.namePath].multiple_servicios, indexMultiple, this.deepCopy(this.dataForm[this.namePath].servicios_nuevos[i]))
            }
            for (let i = 0; i < this.dataForm[this.namePath].servicios_activos.length; i++) {
                let indexMultiple = _.findIndex(this.dataMultiple[this.namePath].multiple_servicios, ['name', this.dataForm[this.namePath].servicios_activos[i].name])
                this.$set(this.dataMultiple[this.namePath].multiple_servicios, indexMultiple, this.deepCopy(this.dataForm[this.namePath].servicios_activos[i]))
            }
            for (let i = 0; i < this.dataMultiple[this.namePath].multiple_servicios.length; i++) {
                if (this.dataMultiple[this.namePath].multiple_servicios[i].mes_periodo.toString() === this.ultimoMes.toString() && this.dataMultiple[this.namePath].multiple_servicios[i].ano_periodo.toString() === this.ultimoAno.toString()) {
                    this.dataMultiple[this.namePath].multiple_servicios[i].mes_periodo = this.dataForm[this.namePath].info_afiliacion.mes_periodo
                    this.dataMultiple[this.namePath].multiple_servicios[i].ano_periodo = this.dataForm[this.namePath].info_afiliacion.ano_periodo
                }
            }
        },
        fichaPrint() {
            window.open(this.url + '/api/pdf/ficha?id=' + this.dataForm[this.namePath].datos_afiliado.id.toString() + '&token=' + this.token, '_blank')
        },
        async changeActive(active) {
            await this.resetDataGet()
            this.active = active
            switch (active) {
                case 1:
                    await this.getDataGet({
                        route: 'get_afldocumentos',
                        data: {
                            others: [
                                ['id_datos_afiliado', this.searchSw.value]
                            ]
                        }
                    })
                    break
                case 2:
                    await this.getDataGet({
                        route: 'get_aflbeneficiarios',
                        data: {
                            others: [
                                ['id_datos_afiliado', this.searchSw.value]
                            ]
                        }
                    })
                    break
                case 3:
                    await this.getDataGet({
                        route: 'get_aflficha',
                        data: {
                            others: [
                                ['id_datos_afiliado', this.swSearchs.datos_afiliado.id]
                            ]
                        }
                    })
                    break
                case 4:
                    await this.getDataGet({
                        route: 'get_aportesficha',
                        data: {
                            others: [
                                ['id_datos_afiliado', this.swSearchs.datos_afiliado.id]
                            ]
                        }
                    })
                    break

            }
        }
    },
}